let RequestStack = require('./requestStack.js').default

const requestStack = {
  install (Vue, options) {
    let requestStack = new RequestStack(Vue, options)

    Vue.requestStack = requestStack

    Object.defineProperties(Vue.prototype, {
      $requestStack: {
        get: function () {
          return requestStack
        }
      }
    })
  }
}

export default requestStack



// WEBPACK FOOTER //
// ./src/plugins/requestStack/index.js